const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/stgag/eCheckin/initialValues.ts';
import { usePatientData } from 'App/store/patient';
import { useSelector } from 'react-redux';
import { useArbeitgeberData } from 'App/store/arbeitgeber';
import { selectUserDetailsFromRegisterWorkItem } from 'App/store/login';
import { normalizePhoneNumber } from 'App/utils/phoneNumberUtils';

export const useECheckinInitialValues = (fallNr?: string) => {
    const [pat, patientIsLoading] = usePatientData();
    const loginDetails = useSelector(selectUserDetailsFromRegisterWorkItem);
    const [arbeitgeberInfos] = useArbeitgeberData();

    const isLoading = patientIsLoading;

    const persAngaben = {
        firstname: pat.get('VORNAME') ?? loginDetails?.get('firstname') ?? '',
        lastname: pat.get('NAME') ?? loginDetails?.get('lastname') ?? '',
        streetAndNumber: pat.get('STRASSE') ?? '',
        plz: pat.get('PLZ') ?? '',
        ort: pat.get('ORT') ?? '',
        country: pat.get('LAND') ?? '',
        gender: pat.get('SEX') ?? '',
        dateOfBirth: (pat.get('GEBDAT') || '').slice(0, 10), // YYYY-MM-DD
        tel: normalizePhoneNumber(pat.get('TELEFON') || pat.get('TELEFON_G')) || '',
        mobile: normalizePhoneNumber(pat.get('TELEFON_M') ?? loginDetails?.get('mobile')) ?? '',
        nationality: pat.get('NATIONALITAET') ?? '',
        zivilstand: pat.get('ZIVILSTAND') ?? '',
        lang: pat.get('SPRACHE') ?? '',
        ahv: pat.get('SOZVERSNR') ?? '',
        religion: pat.get('KONFESSION') ?? '',
        profession: pat.get('BERUF') ?? '',
        email: loginDetails?.get('email') ?? '',
    };
    const arbeitgeber = arbeitgeberInfos?.size && {
        employment: 'employed',
        company: arbeitgeberInfos?.get('Name') ?? '',
        streetAndNumber: arbeitgeberInfos?.get('Strasse') ?? '',
        plz: arbeitgeberInfos?.get('PLZ') ?? '',
        ort: arbeitgeberInfos?.get('Ort') ?? '',
        country: arbeitgeberInfos?.get('Land') ?? '',
        tel: normalizePhoneNumber(arbeitgeberInfos?.get('Tel')) ?? '',
    };
    return [{ persAngaben: persAngaben, arbeitgeber: arbeitgeber }, isLoading];
};
